import { IComment } from "immigram-ui-cmon/src/components/Comments/types";
import { createContext } from "react";

import { IThreadsGroup } from "./types";
import { ISelection } from "../RichEditor/RichEditor";

export interface ICommentsContext {
  hash: string;
  isManager: boolean;
  hidden: boolean;
  showedThreadName?: string;
  focusedCommentId?: string;
  threads: IThreadsGroup;
  addComment?: (name: string, selection?: ISelection, replyId?: string) => void;
  editComment?: (id: string) => void;
  deleteComment?: (id: string, force?: boolean) => Promise<void>;
  saveComment?: (id: string, value: string) => Promise<void>;
  resolveComment?: (name: string, id: string, state: boolean) => void;
  setShowedThreadName?: (name: string) => void;
  setFocusedCommentId?: (id: string) => void;
  comments: IComment[];
}

export const CommentsContext = createContext<ICommentsContext>({
  threads: {},
  hash: "",
  isManager: false,
  hidden: false,
  comments: [],
});
